/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItem } from './PaxCheckChecklistItem';
import {
    PaxCheckChecklistItemFromJSON,
    PaxCheckChecklistItemFromJSONTyped,
    PaxCheckChecklistItemToJSON,
    PaxCheckChecklistItemToJSONTyped,
} from './PaxCheckChecklistItem';
import type { PaxCheckChecklistResolutionStatus } from './PaxCheckChecklistResolutionStatus';
import {
    PaxCheckChecklistResolutionStatusFromJSON,
    PaxCheckChecklistResolutionStatusFromJSONTyped,
    PaxCheckChecklistResolutionStatusToJSON,
    PaxCheckChecklistResolutionStatusToJSONTyped,
} from './PaxCheckChecklistResolutionStatus';
import type { PaxCheckChecklistStatus } from './PaxCheckChecklistStatus';
import {
    PaxCheckChecklistStatusFromJSON,
    PaxCheckChecklistStatusFromJSONTyped,
    PaxCheckChecklistStatusToJSON,
    PaxCheckChecklistStatusToJSONTyped,
} from './PaxCheckChecklistStatus';
import type { PaxCheckQuestion } from './PaxCheckQuestion';
import {
    PaxCheckQuestionFromJSON,
    PaxCheckQuestionFromJSONTyped,
    PaxCheckQuestionToJSON,
    PaxCheckQuestionToJSONTyped,
} from './PaxCheckQuestion';
import type { PaxCheckAllowedDocumentsSet } from './PaxCheckAllowedDocumentsSet';
import {
    PaxCheckAllowedDocumentsSetFromJSON,
    PaxCheckAllowedDocumentsSetFromJSONTyped,
    PaxCheckAllowedDocumentsSetToJSON,
    PaxCheckAllowedDocumentsSetToJSONTyped,
} from './PaxCheckAllowedDocumentsSet';

/**
 * Comprises checklist statuses, questions/answers and checklist items
 * @export
 * @interface PaxCheckChecklist
 */
export interface PaxCheckChecklist {
    /**
     * Checklist id
     * @type {string}
     * @memberof PaxCheckChecklist
     */
    id: string;
    /**
     * 
     * @type {PaxCheckChecklistStatus}
     * @memberof PaxCheckChecklist
     */
    status: PaxCheckChecklistStatus;
    /**
     * Nationality, if set
     * @type {string}
     * @memberof PaxCheckChecklist
     */
    nationality?: string | null;
    /**
     * True if nationality affects rules - require from passenger, unless `nationality` is not null (was provided already)
     * @type {boolean}
     * @memberof PaxCheckChecklist
     */
    hasNationalityQuestion: boolean;
    /**
     * Birthdate, if set
     * @type {Date}
     * @memberof PaxCheckChecklist
     */
    birthdate?: Date | null;
    /**
     * True if birthdate affects rules - require from passenger, unless `birthdate` is not null (was provided already)
     * @type {boolean}
     * @memberof PaxCheckChecklist
     */
    hasBirthdateQuestion: boolean;
    /**
     * List of relevant questions to form the checklist, need to answer all via setAnswers endpoint
     * @type {Array<PaxCheckQuestion>}
     * @memberof PaxCheckChecklist
     */
    questions?: Array<PaxCheckQuestion> | null;
    /**
     * 
     * @type {PaxCheckChecklistResolutionStatus}
     * @memberof PaxCheckChecklist
     */
    resolutionStatus: PaxCheckChecklistResolutionStatus;
    /**
     * Checklist items to resolve for passenger and their status, shown once all relevant questions are answered
     * @type {Array<PaxCheckChecklistItem>}
     * @memberof PaxCheckChecklist
     */
    items?: Array<PaxCheckChecklistItem> | null;
    /**
     * 
     * @type {PaxCheckAllowedDocumentsSet}
     * @memberof PaxCheckChecklist
     */
    allowedTravelDocumentsSet?: PaxCheckAllowedDocumentsSet;
}



/**
 * Check if a given object implements the PaxCheckChecklist interface.
 */
export function instanceOfPaxCheckChecklist(value: object): value is PaxCheckChecklist {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('hasNationalityQuestion' in value) || value['hasNationalityQuestion'] === undefined) return false;
    if (!('hasBirthdateQuestion' in value) || value['hasBirthdateQuestion'] === undefined) return false;
    if (!('resolutionStatus' in value) || value['resolutionStatus'] === undefined) return false;
    return true;
}

export function PaxCheckChecklistFromJSON(json: any): PaxCheckChecklist {
    return PaxCheckChecklistFromJSONTyped(json, false);
}

export function PaxCheckChecklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': PaxCheckChecklistStatusFromJSON(json['status']),
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'hasNationalityQuestion': json['has_nationality_question'],
        'birthdate': json['birthdate'] == null ? undefined : (new Date(json['birthdate'])),
        'hasBirthdateQuestion': json['has_birthdate_question'],
        'questions': json['questions'] == null ? undefined : ((json['questions'] as Array<any>).map(PaxCheckQuestionFromJSON)),
        'resolutionStatus': PaxCheckChecklistResolutionStatusFromJSON(json['resolution_status']),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(PaxCheckChecklistItemFromJSON)),
        'allowedTravelDocumentsSet': json['allowed_travel_documents_set'] == null ? undefined : PaxCheckAllowedDocumentsSetFromJSON(json['allowed_travel_documents_set']),
    };
}

export function PaxCheckChecklistToJSON(json: any): PaxCheckChecklist {
    return PaxCheckChecklistToJSONTyped(json, false);
}

export function PaxCheckChecklistToJSONTyped(value?: PaxCheckChecklist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': PaxCheckChecklistStatusToJSON(value['status']),
        'nationality': value['nationality'],
        'has_nationality_question': value['hasNationalityQuestion'],
        'birthdate': value['birthdate'] == null ? undefined : ((value['birthdate'] as any).toISOString().substring(0,10)),
        'has_birthdate_question': value['hasBirthdateQuestion'],
        'questions': value['questions'] == null ? undefined : ((value['questions'] as Array<any>).map(PaxCheckQuestionToJSON)),
        'resolution_status': PaxCheckChecklistResolutionStatusToJSON(value['resolutionStatus']),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(PaxCheckChecklistItemToJSON)),
        'allowed_travel_documents_set': PaxCheckAllowedDocumentsSetToJSON(value['allowedTravelDocumentsSet']),
    };
}

